import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { formatImage } from '@ifeng/public_method';
import { getAgeStep } from '../../../../utils/utils';

class UserInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const userinfo = this.props.content;

        const { logo, fansNum, weMediaName, title_1, description, location, profession, birthday, sign, unsubNum } =
            userinfo || {};

        return (
            <div
                className={birthday && location && profession ? styles.personal : styles.min_personal}
                style={{ backgroundImage: `url(${formatImage(logo)})` }}>
                <div className={styles.mask} />
                <div className={birthday && location && profession ? styles.contents : styles.min_contents} />
                <div className={styles.portait}>
                    <img src={formatImage(logo)} className={styles.head} />
                    {sign === '大风号' ? <div className={styles.level} /> : ''}
                </div>
                <div className={styles.fansnum}>
                    <div className={styles.follow}>
                        <span>{unsubNum}</span>关注
                    </div>
                    <div className={styles.fans}>
                        <p>
                            <span>{fansNum}</span>粉丝{' '}
                        </p>
                    </div>
                </div>
                <div className={styles.info}>
                    <div className={styles.name}>
                        <span className={styles.names}>{weMediaName}</span>
                        {title_1 ? <span className={styles.dian}>·</span> : ''}
                        <span className={styles.render}>{title_1}</span>
                    </div>
                </div>
                <div className={styles.introduce}>
                    <div className={birthday && location && profession ? styles.base_info : styles.no}>
                        {birthday ? <span>{getAgeStep(birthday)}岁&nbsp;</span> : ''}
                        <span>{location}&nbsp;</span>
                        <span>{profession}</span>
                    </div>
                    <div className={styles.briefs}>
                        <span> 简介：</span>
                        <span className={styles.no_contents}>{description ? description : '这家伙懒得什么都没写'}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(UserInfo);
